import {useAppStore} from '../appStore'

export const toastSelectors = {
  useSuccessMessage: () => useAppStore(s => s.successMessage),
  useErrorMessage: () => useAppStore(s => s.errorMessage),
} as const
